/* eslint-disable */
import { useContext, useEffect } from "react";

import { skipToken } from "@reduxjs/toolkit/query";

import {
  useGetClaimsQuery,
  useGetClaimStatusDefinitionQuery,
  useGetPoliciesAvailableForClaimCreationQuery,
} from "../../store/claimSlice";
import { ClaimCard } from "../../components/claim/ClaimCard";
import { LocalizationContext } from "../../App";
import { FileSearch } from "../../common/icons";
import { RootState, useAppSelector } from "../../store/store";

export const ClaimList = () => {
  const l10n = useContext(LocalizationContext);
  const { data: policiesForClaim, isLoading: arePoliciesForClaimLoading } = useGetPoliciesAvailableForClaimCreationQuery();
  const { data: claims, isLoading } = useGetClaimsQuery();
  const {
    data: claimStatusDefinition,
    isFetching: isStatusDefinitionFetching,
    isLoading: isStatusDefinitionLoading,
    isUninitialized,
    refetch
  } = useGetClaimStatusDefinitionQuery(
    (policiesForClaim && policiesForClaim[0] && policiesForClaim[0].claimDefinitionUniqueCode) ?? skipToken,
    { refetchOnMountOrArgChange: true }
  );
  const language = useAppSelector((s: RootState) => s.app.appLanguage);

  useEffect(() => {
    if (!isUninitialized) refetch();
  }, [isUninitialized, language]);

  if (isLoading || isStatusDefinitionLoading || isStatusDefinitionFetching || arePoliciesForClaimLoading)
    return (
      <div className="loading-screen flex flex-col justify-center items-center">
        <div className="text-body text-xl">{l10n.common.loading}</div>
      </div>
    );

  return (
    <>
      <h2>{l10n.title.insuranceDamage}</h2>

      {claims?.length ? (
        claims.map((claim, index) => (
          <ClaimCard
            claim={claim}
            claimStatusDefinition={claimStatusDefinition}
            key={index}
          />
        ))
      ) : (
        <div className="no-data-screen flex flex-col justify-center items-center text-center text-body px-4">
          <FileSearch className="w-32 h-32 fill-no-data" />
          <div className="mt-4 text-body">{l10n.noData.claims}</div>
        </div>
      )}
    </>
  );
};
